import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';

const HeaderControl = ({ label, href, variant }) => (
  <ButtonInLink
    linkProps={{
      to: href,
      'data-bypass-router': true,
      target: '_blank',
    }}
    isFullWidth
    variant={variant}
  >
    {label}
  </ButtonInLink>
);

const getPageCustomizableHeaderControls = ({
  appPageConfig: { config = {} } = {},
}) => {
  const {
    primary_button_enabled: primaryButtonEnabled,
    primary_button_label: primaryButtonLabel,
    primary_button_url: primaryButtonUrl,
    secondary_button_enabled: secondaryButtonEnabled,
    secondary_button_label: secondaryButtonLabel,
    secondary_button_url: secondaryButtonUrl,
  } = config;

  const primaryButton = primaryButtonEnabled && primaryButtonUrl && (
    <HeaderControl label={primaryButtonLabel} href={primaryButtonUrl} />
  );

  const secondaryButton = secondaryButtonEnabled && secondaryButtonUrl && (
    <HeaderControl
      label={secondaryButtonLabel}
      href={secondaryButtonUrl}
      variant="secondary"
    />
  );

  return {
    controls: [primaryButton, secondaryButton].filter(Boolean),
    primaryButton,
    secondaryButton,
  };
};

export default getPageCustomizableHeaderControls;
